export enum TafaceTypePlanEnum {
  LITE = 'LITE',
  PREMIUM = 'PREMIUM',
}
